import React from "react";
import Text from "onnit-ui/lib/text/Text";
import Box from "onnit-ui/lib/box/Box";
import CartProductInterface from "../../../../interfaces/cart/CartProduct";

interface Props {
    cartProduct: CartProductInterface;
    onUndoSave: () => void;
}

const SavedCartProduct = ({ cartProduct, onUndoSave }: Props) => (
    <Box py={3} borderBottom="1px solid" borderColor="grays.1">
        <Box display="flex" bg="grays.0" justifyContent="center" p={4} borderRadius="4px">
            <Text
                as="p"
                fontSize={1}
                role="status"
                aria-live="polite"
            >
                {cartProduct.product.name} was moved to your{" "}
                <a
                    href="/cart/favorites/"
                    target="_blank"
                    rel="noopener"
                    style={{
                        fontSize: "inherit",
                        textDecoration: "underline",
                    }}
                >Favorites.
                </a>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Text
                    as="button"
                    fontSize={1}
                    display="inline"
                    onClick={onUndoSave}
                >
                    Undo
                </Text>
            </Text>
        </Box>
    </Box>
);

export default SavedCartProduct;
